
import { Button, ComponentStyle} from '@/imports-files/components/delete-candidate-modal';
import { closeJob}  from '@/imports-files/pages/clients/candidates/kanban';
import Modal from "@/components/common-modal/modal";

export function CloseJobModal({setCloseJobModal, job_id,  router, title})
{
  return(
          <Modal
            type="confirmation"
            message={
              <>Are you sure you want to archive the {title}? This action cannot be undone.
              <br /><br />
              If you would like to close the job to new applicants, please see our support guide{" "}<a href="https://help.charliehr.com/en/articles/9498142-integrating-job-boards-with-recruit#h_3845609880" target="_blank"><strong>here</strong></a>.</>
            }
            texts={{
              button1_text: "Cancel",
              button2_text: "Confirm",
            }}
            closeModal={() => setCloseJobModal(false)}
            btnAction={() => {
              closeJob(job_id, router)
            }}
          />
        )
} 

